const SvgHandoffIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path d="M6 22V8.775q-2.275-.6-3.637-2.513A7.17 7.17 0 0 1 1 2h2q0 2.074 1.338 3.537Q5.675 7 7.75 7h2.5q.75 0 1.4.275t1.175.8L16 12.5s-.5 0-1 .5-.5 1-.5 1L12 10.05V22h-2v-6H8v6zM9 6q-.825 0-1.412-.588A1.92 1.92 0 0 1 7 4q0-.825.588-1.413A1.93 1.93 0 0 1 9 2q.825 0 1.413.587Q11 3.175 11 4q0 .824-.587 1.412A1.93 1.93 0 0 1 9 6M17.724 12.448a1.724 1.724 0 1 0 0-3.448 1.724 1.724 0 0 0 0 3.448" />
      <path d="M19.724 13h-3.448a.86.86 0 0 0-.69.345L13 16.793l1.38 1.035 1.034-1.38v6.035h1.724v-3.449h1.724v3.449h1.724v-6.035l1.035 1.38L23 16.793l-2.586-3.448a.86.86 0 0 0-.69-.345" />
    </g>
  </svg>
);

export default SvgHandoffIcon;
